import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import BookingPage from '../components/PublicBooking/BookingPage';

const PublicBookingPage: React.FC = () => {
  const { clinicPath } = useParams<{ clinicPath?: string }>();
  const [searchParams] = useSearchParams();
  
  // Get clinic ID from URL query parameter
  const clinicId = searchParams.get('clinic') || undefined;
  
  // Get service ID from URL query parameter (for direct service selection)
  const serviceId = searchParams.get('service') || undefined;
  
  // Get return URL from query parameter (for multi-portal support)
  const returnUrl = searchParams.get('returnUrl') || undefined;
  
  console.log('Public Booking Page Loading:');
  console.log('- Clinic Path:', clinicPath);
  console.log('- Clinic ID:', clinicId);
  console.log('- Service ID:', serviceId);
  console.log('- Return URL:', returnUrl);
  
  return (
    <BookingPage 
      clinicId={clinicId} 
      clinicPath={clinicPath}
      serviceId={serviceId}
      returnUrl={returnUrl}
    />
  );
};

export default PublicBookingPage;